// @flow

export const TREE = 'assetsModule'
export const TABLE_BRANCH = 'table'
export const OPERATIONS_BRANCH = 'operations'
export const UPLOAD_OPERATIONS_BRANCH = 'uploadOperations'

// Operations
export const ADD_ASSET = '@assetsModule/ADD_ASSET'
export const EDIT_ASSETS = '@assetsModule/EDIT_ASSETS'
export const DELETE_ASSETS = '@assetsModule/DELETE_ASSETS'

export const EDIT = 'EDIT'
export const DELETE = 'DELETE'
export const ADD = 'ADD'

// different module name? grab constant from elsewhere?
// export const UPLOAD_FIELD_BORDERS = '@assetsModule/UPLOAD_FIELD_BORDERS'
